import React from 'react'
import { Switch, useRouteMatch } from 'react-router-dom'
import { SecureRoute } from '@okta/okta-react'
import NotFoundView from '../common/NotFoundView'
import ReadingListHome from './ReadingListHome'

function ReadingListIndex () {
  const { path } = useRouteMatch()

  return (
    <Switch>
      <SecureRoute path={`${path}`}>
        <ReadingListHome />
      </SecureRoute>
      <SecureRoute path='*'>
        <NotFoundView />
      </SecureRoute>
    </Switch>
  )
}

export default ReadingListIndex
